import {
  iamAccountEntityRaw,
  IAMAccountEntityRaw
} from "@youm-front/iam-account/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class IAMAccountCredentialsUpdateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountCredentialsUpdateResponseDTO.validationSchema()
  );

  constructor(readonly data: IAMAccountCredentialsUpdateResponseDTORaw) {
    JsonSchemaValidator.validate(
      IAMAccountCredentialsUpdateResponseDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["account"],
      properties: {
        account: iamAccountEntityRaw
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountCredentialsUpdateResponseDTORaw {
  account: IAMAccountEntityRaw;
}
